import { transformAllContentItems } from "../dataTransform/library";
import { fetch } from "../../fetch/graphql";
import { GRAPHQL_URL } from "./constants";
import allContentItemsBySubjectQuery from "../../fetch/graphql/queries/subjectContent";
import log from "../logger/library";

/**
 * @param {string} subjects valid query string
 * @param {number} [pageSize=5]
 * @see {@link https://www.cbc.ca/aggregate_api/v1/swagger-ui.html#!/Items/listItems} subjects documentation
 */
export const fetchSubjects = (subjects, pageSize = 5) => {
    const concepts = subjects ? `subject:${subjects}` : "";

    return fetch(GRAPHQL_URL, {
        query: allContentItemsBySubjectQuery,
        variables: {
            concepts,
            pageSize,
        },
    })
        .then((response) =>
            transformAllContentItems(response.allContentItems.nodes)
        )
        .catch((error) =>
            log.error(
                `(fetchSubjects) Unable to fetch subjects ${subjects}`,
                error
            )
        );
};

/**
 * Return query for union of subjects
 * @param {Array.<string>} subjects
 * @return {string} subject query for union of all given subjects
 */
export const subjectUnion = (subjects) => subjects.join("|");

/**
 * Validates if value is a string and is not empty
 * @param {string} value
 * @returns true if the string is of string-type and longer than 0 chars
 */
export const isValidString = (value) => {
    return typeof value === "string" && value.length > 0;
};

/*
 * Function that checks if a media/audio has a valid clipID
 * The media parameter is for the videos/audios
 * The audio parameter is for the episode/segments
 * @param {Object} media
 * @param {Object} audio
 * @return {Boolean}
 */
export const hasLeadMediaClipID = (media, audio) => {
    if (isValidString(media?.clipID)) return true;
    if (isValidString(audio?.clipID)) return true;
    return false;
};
